<template>
  <div class="main-index">
    <div class="opportunity-head">
      <img class="main-img" src="~@/assets/activity/broadcast-alive.png" />
      <div class="fixed-bottom">
        <img class="btn-img" @click="goAlive" src="~@/assets/activity/broadcast-btn.png" />
      </div>
      
    </div>

  </div>
</template>
<script>
import liveMixin from '@/views/uplusLive/index/liveMixin.js'
export default {
    name: 'broadcastAlive',
    mixins: [liveMixin],
    methods:{
       goAlive(){
        this.apiLivePolyvDetail({id:window.competitionResource.broadcastAliveId || '1119'})
       }     
    },
}
</script>
<style lang="scss" scoped>
.main-img{
  width: 100%;
  min-width: 1200px
}
.fixed-bottom{
   width: 100%;
  // position: fixed;
    bottom: 30px;
    position: sticky;
    min-width: 1200px;
}
.btn-img{
  cursor: pointer;
    margin: 0 auto;
    display: block;
    margin: -10% auto 0;
    width: 20%;
}
</style>




// WEBPACK FOOTER //
// src/gtn/views/activities/broadcast/broadcast_one.vue